import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

export default {
  init: (env) => {
    Bugsnag.start({
      apiKey: '83696aa90281146381f7c589185b2950',
      plugins: [new BugsnagPluginVue()],
      enabledReleaseStages: [env],
      releaseStage: env
    })
  },

  install: (app) => {
    const plugin = Bugsnag.getPlugin('vue')
    if (plugin?.install) {
      plugin.install(app)
    }
  }
}
